import React from "react";
import PropTypes from "prop-types";
import { createInputFields, createRadioFields } from "../common/utils";

const Habit = ({ data }) => {
  return (
    <fieldset>
      <table className="hdf-form">
        <thead>
          <tr className="table-title">
            <th colSpan="17">D) Habits Of Proposed Employee / Eligible Member</th>
          </tr>
          <tr className="text-center">
            <td rowSpan="3" colSpan="2">
              Please tick Yes or No. If Yes, please provide details in the space provided.
            </td>
            <td rowSpan="2" colSpan="3">
              Employee
            </td>
            <td colSpan="12" className="font-italic">
              <b>Please Complete Where Applicable</b>
            </td>
          </tr>
          <tr className="text-center">
            <td colSpan="3">Spouse</td>
            <td colSpan="3">Child 1</td>
            <td colSpan="3">Child 2</td>
            <td colSpan="3">Child 3</td>
          </tr>
          <tr className="yes-no-row text-center">
            <td>Yes</td>
            <td>or</td>
            <td>No</td>
            <td>Yes</td>
            <td>or</td>
            <td>No</td>
            <td>Yes</td>
            <td>or</td>
            <td>No</td>
            <td>Yes</td>
            <td>or</td>
            <td>No</td>
            <td>Yes</td>
            <td>or</td>
            <td>No</td>
          </tr>
        </thead>
        <tbody>
          <tr className="habits-checkbox-row no-border-bottom">
            <td rowSpan="3">1</td>
            <td>
              Have you ever smoked in the last 12 months?
              <br />
              If Yes, please provide details of smoking:
            </td>
            {createRadioFields(data, "EmployeeSmoke")}
            {createRadioFields(data, "SpouseSmoke")}
            {createRadioFields(data, "FirstChildSmoke")}
            {createRadioFields(data, "SecondChildSmoke")}
            {createRadioFields(data, "ThirdChildSmoke")}
          </tr>
          <tr className="no-border-top no-border-bottom">
            <td className="no-border-left">a. No. of sticks you smoke per day:</td>
            {createInputFields(data, "EmployeeSmokeQuantity")}
            {createInputFields(data, "SpouseSmokeQuantity")}
            {createInputFields(data, "FirstChildSmokeQuantity")}
            {createInputFields(data, "SecondChildSmokeQuantity")}
            {createInputFields(data, "ThirdChildSmokeQuantity")}
          </tr>
          <tr className="no-border-top no-border-bottom">
            <td className="no-border-left">b. No. of years since you have been smoking:</td>
            {createInputFields(data, "EmployeeSmokeNoOfYears")}
            {createInputFields(data, "SpouseSmokeNoOfYears")}
            {createInputFields(data, "FirstChildSmokeNoOfYears")}
            {createInputFields(data, "SecondChildSmokeNoOfYears")}
            {createInputFields(data, "ThirdChildSmokeNoOfYears")}
          </tr>
          <tr className="habits-checkbox-row no-border-bottom">
            <td rowSpan="3">2</td>
            <td>
              Do you consume beer, wine or other alcoholic beverages?
              <br />
              If Yes, please provide details of alcohol consumption:
            </td>
            {createRadioFields(data, "EmployeeConsumeAlcohol")}
            {createRadioFields(data, "SpouseConsumeAlcohol")}
            {createRadioFields(data, "FirstChildConsumeAlcohol")}
            {createRadioFields(data, "SecondChildConsumeAlcohol")}
            {createRadioFields(data, "ThirdChildConsumeAlcohol")}
          </tr>
          <tr className="no-border-top no-border-bottom">
            <td className="no-border-left">a. Type of alcohol taken:</td>
            {createInputFields(data, "EmployeeAlcoholType")}
            {createInputFields(data, "SpouseAlcoholType")}
            {createInputFields(data, "FirstChildAlcoholType")}
            {createInputFields(data, "SecondChildAlcoholType")}
            {createInputFields(data, "ThirdChildAlcoholType")}
          </tr>
          <tr className="no-border-top no-border-bottom">
            <td className="no-border-left">
              b. Average weekly consumption with units of measurement:
            </td>
            {createInputFields(data, "EmployeeAlcoholQuantity")}
            {createInputFields(data, "SpouseAlcoholQuantity")}
            {createInputFields(data, "FirstChildAlcoholQuantity")}
            {createInputFields(data, "SecondChildAlcoholQuantity")}
            {createInputFields(data, "ThirdChildAlcoholQuantity")}
          </tr>
          <tr className="habits-checkbox-row no-border-bottom">
            <td rowSpan="3">3</td>
            <td rowSpan="3">
              Do you engage in or intend to engage in any sport(s) or occupation of a dangerous /
              hazardous nature? E.g. scuba / skin diving, motor racing, military / private flying
              other than as a fare paying passenger, parachuting, etc?
              <br />
              If Yes, please state details on the type of sports you participate in:
            </td>
            {createRadioFields(data, "EmployeeAdventure")}
            {createRadioFields(data, "SpouseAdventure")}
            {createRadioFields(data, "FirstChildAdventure")}
            {createRadioFields(data, "SecondChildAdventure")}
            {createRadioFields(data, "ThirdChildAdventure")}
          </tr>
          <tr className="no-border-top no-border-bottom">
            {createInputFields(data, "EmployeeAdventureInfo")}
            {createInputFields(data, "SpouseAdventureInfo")}
            {createInputFields(data, "FirstChildAdventureInfo")}
            {createInputFields(data, "SecondChildAdventureInfo")}
            {createInputFields(data, "ThirdChildAdventureInfo")}
          </tr>
          <tr className="no-border-top no-border-bottom">
            {createInputFields(data, "EmployeeAdventureInfoDetails")}
            {createInputFields(data, "SpouseAdventureInfoDetails")}
            {createInputFields(data, "FirstChildAdventureInfoDetails")}
            {createInputFields(data, "SecondChildAdventureInfoDetails")}
            {createInputFields(data, "ThirdChildAdventureInfoDetails")}
          </tr>
        </tbody>
      </table>
    </fieldset>
  );
};

Habit.propTypes = {
  data: PropTypes.object,
};

export default Habit;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/Habit.jsx